<template>
  <div class="bg company">
    <headerCom></headerCom>
    <div class="w-body title-wrap" style="margin:60px auto 40px">
      <div class="name">企业信息</div>
      <div class="interval-line"></div>
      <div class="e-name">ENTERPRISE INFORMATION</div>
    </div>
    <div class="w-body info">
      <div class="img">
        <img src="../assets/images/companyInfo/info_left.png" alt="" />
      </div>
      <div class="mess">
        <div class="title">杭州卓智力创信息技术有限公司</div>
        <div class="e-title">
          HANGZHOU ZHUO ZHILICHUANG INFORMATION TECHNOLOGY CORPORATION
        </div>
        <p>
          杭州卓智力创信息技术有限公司2017年6月成立,依托团队多年来在能源、公安、交通、行政执法、自然资源及政府部门等不同应用的技术实践和经验积累，着眼于国内市场需求，以“用户满意”为根本出发点，以“卓越、智汇、合力、创新”为企业思想，以开拓性发展思路为用户提供最优秀、适时的技术咨询、人工智能技术开发和大数据应用平台支撑服务。
        </p>
      </div>
    </div>
    <div class="cen">
      <div class="w-body flex-between">
        <div class="item">
          <img src="../assets/images/companyInfo/cen_01.png" alt="" />
          <p class="title">企业宗旨</p>
          <p>尊重用户、以人为本，追求个人、公司、客户、合作伙伴共嬴。</p>
        </div>
        <div class="item">
          <img src="../assets/images/companyInfo/cen_02.png" alt="" />
          <p class="title">核心理念</p>
          <p>
            基于大数据应用的人工智能解决方案服务商为目标，秉承“卓越、智汇、合力、创新”的核心理念全力、用心、真诚服务用户。
          </p>
        </div>
        <div class="item">
          <img src="../assets/images/companyInfo/cen_03.png" alt="" />
          <p class="title">管理理念</p>
          <p>团结协作、合力进取、精益求精，打造一支可战斗的队伍。</p>
        </div>
        <div class="item">
          <img src="../assets/images/companyInfo/cen_04.png" alt="" />
          <p class="title">经营理念</p>
          <p>合法经营、踏实做事、诚信服务，与用户相互促进、共同发展。</p>
        </div>
      </div>
    </div>
    <div class="bg-white" style="padding:21px 0 19px;">
      <div class="w-body title-wrap">
        <div class="name">大事记</div>
        <div class="interval-line"></div>
        <div class="e-name">MEMORABILIA</div>
      </div>
      <img
        src="../assets/images/companyInfo/info.png"
        alt=""
        style="max-width:1240px;margin:0 auto;"
      />
    </div>
    <div class="bg-white" style="padding-top:60px">
      <div class="w-body title-wrap" style="margin-bottom:42px;">
        <div class="name">公司资质</div>
        <div class="interval-line"></div>
        <div class="e-name">COMPANY QUALIFICATION</div>
      </div>
      <div class="flex-between w-body">
        <div class="zs-wrap">
          <img src="../assets/images/companyInfo/zs_01.png" alt="" />
          <p>全国政府采购重合同守信用AAA</p>
        </div>
        <div class="zs-wrap">
          <img src="../assets/images/companyInfo/zs_02.png" alt="" />
          <p>中华人民共和国信用等级</p>
        </div>
        <div class="zs-wrap">
          <img src="../assets/images/companyInfo/zs_03.png" alt="" />
          <p>浙江省科技型中小企业认定</p>
        </div>
      </div>
      <div class="flex-between w-body">
        <div class="zs-wrap">
          <img src="../assets/images/companyInfo/zs_04.png" alt="" />
          <p>国家高新技术企业</p>
        </div>
        <div class="zs-wrap">
          <img src="../assets/images/companyInfo/zs_05.png" alt="" />
          <p>ISO质量体系认定</p>
        </div>
        <div class="zs-wrap">
          <img src="../assets/images/companyInfo/zs_06.png" alt="" />
          <p>环境认定</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headerCom from "../components/header";
export default {
  name: "page",
  components: {
    headerCom,
  },
  data() {
    return {
      httpUrl: process.env.VUE_APP_URL,
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
@import "../assets/css/base.less";
</style>
